import axios from "axios";
import { getToken } from "./localstorage";
import { updateButtonStatus } from "@/utils/contentReady/helper";
import { fetchFormatTemplate } from "@/utils/sharePricePerformance/fetchFormatTemplates";
import { getContentReadyMode } from "@/utils/slides/slidesJobs";

export const fetchChartDocuments = async (powerpointId: string): Promise<any[]> => {
  const apiUrl = process.env.API_URL;
  const token = await getToken();

  try {
    const response = await axios.get(`${apiUrl}/document-part-by-user`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        powerpointId: powerpointId,
      },
    });

    const data = await response.data;

    const transformed = await Promise.all(
      data.files.map(async (file, index) => {
        const chartFile = file;
        const binaryString = window.atob(chartFile.content);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const documentContent = JSON.parse(file.documentContent);
        const placeholder = documentContent.placeholder;
        const metadata = documentContent.metadata || {};
        const formatId = documentContent.formatId;
        const formatTemplateRawData = formatId ? await fetchFormatTemplate(formatId) : null;
        const formatTemplate = JSON.parse(formatTemplateRawData.formatData);
        return {
          id: index + 1,
          documentPartId: file.documentPartId,
          documentId: file.documentId,
          title: `Chart ${index + 1}`,
          contentType: "Share Price Performance || Line Chart",
          content: `data:${file.mimeType};base64,${file.content}`,
          blob: new Blob([bytes], { type: chartFile.mimeType }),
          placeholder,
          titlePlaceholder: documentContent.titlePlaceholder,
          subTitlePlaceholder: documentContent.subTitlePlaceholder,
          subtitleRight: documentContent.subtitleRight,
          metadata,
          formatId: documentContent.formatId,
          fontsSection: formatTemplate.fontsSection,
          isProgress: file.isProgress,
          hasChartError: file.hasChartError,
        };
      })
    );

    if (transformed.length === 0) {
      await updateButtonStatus(false);
      if (getContentReadyMode() !== "slides") {
        Office.addin.hide();
      }
    } else {
      await updateButtonStatus(true);
    }

    return transformed;
  } catch (e) {
    console.log(e);
    return [];
  }
};
